module.exports = __webpack_public_path__ + "img/angry.823b1b89.png";